import styled, { css } from "styled-components";
import { Atom } from 'AppReact';
import device from 'utils/device';

const Title = styled.div`
  ${({ theme }) => css`
    font-size:  20px;
    color: ${theme?.colour?.secondary ?? "#04333b"};
    font-weight:  ${theme?.fonts?.fontWeight?.pageTitle ?? "600"};
    @media ${device.laptop} {
      font-size:  ${theme?.fonts?.fontSize?.pageTitle ?? "24px"} ;
    }
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template: Title })